import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { AuthLayout } from '../layouts/AuthLayout';
import { Alert, Field } from '../components/Field';
import { api, type ApiError } from '../api/client';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState<ApiError | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await api('/auth/forgot-password', { method: 'POST', body: JSON.stringify({ email }) });
      setSent(true);
    } catch (caught) {
      setError(caught as ApiError);
    } finally {
      setBusy(false);
    }
  }

  return (
    <AuthLayout>
      <h2 className="auth__title">Reset your password</h2>
      <p className="auth__lede">We will email you a link to set a new one.</p>

      {error ? <Alert kind="error" title={error.message} /> : null}
      {sent ? (
        <Alert
          kind="success"
          title="If that address has an account, a reset link is on its way. It expires in 60 minutes."
        />
      ) : null}

      <form onSubmit={onSubmit} noValidate>
        <Field
          label="Email address"
          type="email"
          autoComplete="username"
          required
          value={email}
          onChange={(event) => setEmail(event.target.value)}
        />
        <button className="btn" type="submit" disabled={busy}>
          {busy ? 'Sending…' : 'Send reset link'}
        </button>
      </form>

      <p className="auth__footnote">
        <Link to="/login">Back to sign in</Link>
      </p>
    </AuthLayout>
  );
}
